export const MATCHES = {
  groupA: [
    {
      id: '3357105',
      date: '2021-06-11T19:00:00.000Z',
      localTeam: {
        name: 'Турция',
        countryCode: 'TR',
        score: 0
      },
      visitorTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 3
      }
    },
    {
      id: '3357108',
      date: '2021-06-12T13:00:00.000Z',
      localTeam: {
        name: 'Уэльс',
        countryCode: 'GB-WLS',
        score: 1
      },
      visitorTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 1
      }
    },
    {
      id: '3357116',
      date: '2021-06-16T16:00:00.000Z',
      localTeam: {
        name: 'Турция',
        countryCode: 'TR',
        score: 0
      },
      visitorTeam: {
        name: 'Уэльс',
        countryCode: 'GB-WLS',
        score: 2
      }
    },
    {
      id: '3357115',
      date: '2021-06-16T19:00:00.000Z',
      localTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 3
      },
      visitorTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 0
      }
    },
    {
      id: '3357121',
      date: '2021-06-20T16:00:00.000Z',
      localTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 1
      },
      visitorTeam: {
        name: 'Уэльс',
        countryCode: 'GB-WLS',
        score: 0
      }
    },
    {
      id: '3357122',
      date: '2021-06-20T16:00:00.000Z',
      localTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 3
      },
      visitorTeam: {
        name: 'Турция',
        countryCode: 'TR',
        score: 1
      }
    }
  ],
  groupB: [
    {
      id: '3357107',
      date: '2021-06-12T16:00:00.000Z',
      localTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 0
      },
      visitorTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 1
      }
    },
    {
      id: '3357106',
      date: '2021-06-12T19:00:00.000Z',
      localTeam: {
        name: 'Бельгия',
        countryCode: 'BE',
        score: 3
      },
      visitorTeam: {
        name: 'Россия',
        countryCode: 'RU',
        score: 0
      }
    },
    {
      id: '3357114',
      date: '2021-06-16T13:00:00.000Z',
      localTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 0
      },
      visitorTeam: {
        name: 'Россия',
        countryCode: 'RU',
        score: 1
      }
    },
    {
      id: '3357113',
      date: '2021-06-17T16:00:00.000Z',
      localTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 1
      },
      visitorTeam: {
        name: 'Бельгия',
        countryCode: 'BE',
        score: 2
      }
    },
    {
      id: '3357123',
      date: '2021-06-21T19:00:00.000Z',
      localTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 0
      },
      visitorTeam: {
        name: 'Бельгия',
        countryCode: 'BE',
        score: 2
      }
    },
    {
      id: '3357124',
      date: '2021-06-21T19:00:00.000Z',
      localTeam: {
        name: 'Россия',
        countryCode: 'RU',
        score: 1
      },
      visitorTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 4
      }
    }
  ],
  groupC: [
    {
      id: '3721521',
      date: '2021-06-13T16:00:00.000Z',
      localTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 3
      },
      visitorTeam: {
        name: 'С.Македония',
        countryCode: 'MK',
        score: 1
      }
    },
    {
      id: '3357110',
      date: '2021-06-13T19:00:00.000Z',
      localTeam: {
        name: 'Нидерланды',
        countryCode: 'NL',
        score: 3
      },
      visitorTeam: {
        name: 'Украина',
        countryCode: 'UA',
        score: 2
      }
    },
    {
      id: '3721525',
      date: '2021-06-17T13:00:00.000Z',
      localTeam: {
        name: 'Украина',
        countryCode: 'UA',
        score: 2
      },
      visitorTeam: {
        name: 'С.Македония',
        countryCode: 'MK',
        score: 1
      }
    },
    {
      id: '3357117',
      date: '2021-06-17T19:00:00.000Z',
      localTeam: {
        name: 'Нидерланды',
        countryCode: 'NL',
        score: 2
      },
      visitorTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 0
      }
    },
    {
      id: '3357125',
      date: '2021-06-21T16:00:00.000Z',
      localTeam: {
        name: 'Украина',
        countryCode: 'UA',
        score: 0
      },
      visitorTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 1
      }
    },
    {
      id: '3973613',
      date: '2021-06-21T16:00:00.000Z',
      localTeam: {
        name: 'С.Македония',
        countryCode: 'MK',
        score: 0
      },
      visitorTeam: {
        name: 'Нидерланды',
        countryCode: 'NL',
        score: 3
      }
    }
  ],
  groupD: [
    {
      id: '3357109',
      date: '2021-06-13T13:00:00.000Z',
      localTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 1
      },
      visitorTeam: {
        name: 'Хорватия',
        countryCode: 'HR',
        score: 0
      }
    },
    {
      id: '3721522',
      date: '2021-06-14T13:00:00.000Z',
      localTeam: {
        name: 'Шотландия',
        countryCode: 'GB-SCT',
        score: 0
      },
      visitorTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 2
      }
    },
    {
      id: '3357118',
      date: '2021-06-18T16:00:00.000Z',
      localTeam: {
        name: 'Хорватия',
        countryCode: 'HR',
        score: 1
      },
      visitorTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 1
      }
    },
    {
      id: '3350999',
      date: '2021-06-18T19:00:00.000Z',
      localTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 0
      },
      visitorTeam: {
        name: 'Шотландия',
        countryCode: 'GB-SCT',
        score: 0
      }
    },
    {
      id: '3357126',
      date: '2021-06-22T19:00:00.000Z',
      localTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 0
      },
      visitorTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 1
      }
    },
    {
      id: '3973614',
      date: '2021-06-22T19:00:00.000Z',
      localTeam: {
        name: 'Хорватия',
        countryCode: 'HR',
        score: 3
      },
      visitorTeam: {
        name: 'Шотландия',
        countryCode: 'GB-SCT',
        score: 1
      }
    }
  ],
  groupE: [
    {
      id: '3721523',
      date: '2021-06-14T16:00:00.000Z',
      localTeam: {
        name: 'Польша',
        countryCode: 'PL',
        score: 1
      },
      visitorTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 2
      }
    },
    {
      id: '3357111',
      date: '2021-06-14T19:00:00.000Z',
      localTeam: {
        name: 'Испания',
        countryCode: 'ES',
        score: 0
      },
      visitorTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 0
      }
    },
    {
      id: '3721526',
      date: '2021-06-18T13:00:00.000Z',
      localTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 1
      },
      visitorTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 0
      }
    },
    {
      id: '3357119',
      date: '2021-06-19T19:00:00.000Z',
      localTeam: {
        name: 'Испания',
        countryCode: 'ES',
        score: 1
      },
      visitorTeam: {
        name: 'Польша',
        countryCode: 'PL',
        score: 1
      }
    },
    {
      id: '3357128',
      date: '2021-06-23T16:00:00.000Z',
      localTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 3
      },
      visitorTeam: {
        name: 'Польша',
        countryCode: 'PL',
        score: 2
      }
    },
    {
      id: '3973615',
      date: '2021-06-23T16:00:00.000Z',
      localTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 0
      },
      visitorTeam: {
        name: 'Испания',
        countryCode: 'ES',
        score: 5
      }
    }
  ],
  groupF: [
    {
      id: '3721524',
      date: '2021-06-15T16:00:00.000Z',
      localTeam: {
        name: 'Венгрия',
        countryCode: 'HU',
        score: 0
      },
      visitorTeam: {
        name: 'Португалия',
        countryCode: 'PT',
        score: 3
      }
    },
    {
      id: '3357112',
      date: '2021-06-15T19:00:00.000Z',
      localTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 1
      },
      visitorTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 0
      }
    },
    {
      id: '3973612',
      date: '2021-06-19T13:00:00.000Z',
      localTeam: {
        name: 'Венгрия',
        countryCode: 'HU',
        score: 1
      },
      visitorTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 1
      }
    },
    {
      id: '3357120',
      date: '2021-06-19T16:00:00.000Z',
      localTeam: {
        name: 'Португалия',
        countryCode: 'PT',
        score: 2
      },
      visitorTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 4
      }
    },
    {
      id: '3357127',
      date: '2021-06-23T19:00:00.000Z',
      localTeam: {
        name: 'Португалия',
        countryCode: 'PT',
        score: 2
      },
      visitorTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 2
      }
    },
    {
      id: '3973616',
      date: '2021-06-23T19:00:00.000Z',
      localTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 2
      },
      visitorTeam: {
        name: 'Венгрия',
        countryCode: 'HU',
        score: 2
      }
    }
  ]
};
